import React from "react";
import ReactDOM from "react-dom";
import "../styles/loading-spinner.css";
import image from "../images/logo.gif"

interface Props {
  show?: boolean;
}

export const LoadingSpinner: React.FC<Props> = ({ show = true }) => {
  if (!show) {
    return null;
  }
  // Portal to body so position:fixed covers the viewport, including sticky table headers.
  return ReactDOM.createPortal(
    <div
      className="fixed flex items-center justify-center bg-black"
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 10000,
      }}
    >
      <div className="rounded-full border-8 border-t-8 border-gray-200 h-64 w-64"><img className="" src={image} /></div>
    </div>,
    document.body
  );
};
